<template>
	<div class="page">
		<header>
			<h1>
				CARPORT
				<br />véhicules
			</h1>
			<h3>
				Structure indépendante
				<br />au bâtiment d'habitation
			</h3>
		</header>
		<article>
			<div class="gauche">
				<h2>Sans</h2>
				<div
					:class="carport == 'Non' ? 'selected option' : 'option'"
					id="sans"
					@click="handleCarport('sans', 'Non')"
				>
					<img src="../assets/05-sans.png" />
				</div>
			</div>
			<div class="gauche">
				<h2>1 voiture</h2>
				<div
					:class="carport == 'Oui, 1 véhicule' ? 'selected option' : 'option'"
					id="un"
					@click="handleCarport('un', 'Oui, 1 véhicule')"
				>
					<img src="../assets/05-1voiture.png" />
				</div>
			</div>
			<div class="droite">
				<h2>2 voitures</h2>
				<div
					:class="carport == 'Oui, 2 véhicules' ? 'selected option' : 'option'"
					id="deux"
					@click="handleCarport('deux', 'Oui, 2 véhicules')"
				>
					<img src="../assets/05-2voitures.png" />
				</div>
			</div>
		</article>
		<footer>
			<router-link to="/garage" class="button back">
				<i class="fa fa-angle-left"></i>
			</router-link>
			<router-link v-if="ready || carport.length > 1" to="/coordonnees" class="button medium">
				Finalisation
				<i class="fa fa-angle-right"></i>
			</router-link>
		</footer>
	</div>
</template>
<script>
	export default {
		name: "Garage",
		components: {},
		data() {
			return {
				ready: false
			};
		},
		computed: {
			carport() {
				return this.$store.state.carport;
			}
		},
		methods: {
			handleCarport(element, value) {
				this.ready = true;
				this.$store.commit("setCarPort", value);
				var options = document.querySelectorAll(".option");
				var cible = document.getElementById(element);
				options.forEach(el => {
					el.classList.remove("selected");
				});
				cible.classList.add("selected");
			}
		},
		mounted() {
			this.$store.commit("setTimer", 60);
		}
	};
</script>

<style lang="less">
</style>